import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./joiningRequest.css";
import Profile from "../../../../assets/images/fanGroup/unknown.png";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
const JoiningRequestModal = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  return (
    <>
      <Modal
        {...props}
        size="ml"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="row BGIJoin pb-3">
          <center>
            <img
              src={imageCdnUrl + props.member.user?.image}
              alt=""
              className="proJoin mb-3 mt-4"
            />
          </center>
          <center>
            <h4 className="fw-bold text-warning">
              {" "}
              {props.member.user?.first_name} {props.member.user?.last_name}
            </h4>
          </center>
          <div className="main mx-5">
            <div className="row text-light">
              <td className="d-flex">
                <tr className="TDwith">Owner Star Name </tr>
                <tr>: {props.member?.star_name}</tr>
              </td>
              <td className="d-flex">
                <tr className="TDwith">Email </tr>
                <tr>: {props.member.user?.email}</tr>
              </td>
              <td className="d-flex">
                <tr className="TDwith">Phone </tr>
                <tr>: {props.member.user?.phone}</tr>
              </td>
            </div>
          </div>
          {/* <center><button className='btnJoin btn mt-3 border-success text-success px-5 fw-bold'>Profile</button></center> */}
        </div>
      </Modal>
    </>
  );
};

export default JoiningRequestModal;
